import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "player-volume" }

import { onBeforeMount, ref } from 'vue'

import type { VolumeControl } from '@/services/player'
import VueSlider from 'vue-slider-component'


export default /*@__PURE__*/_defineComponent({
  __name: 'Volume',
  props: {
    volumeControl: {}
  },
  setup(__props: any) {

const props = __props

const value = ref<number>()

onBeforeMount(() => {
  updateVolume()
})

function inputChange(value: number): void {
  const percent = value / 100
  if (props.volumeControl.value !== percent && !isNaN(percent)) {
    props.volumeControl.change(percent)
  }
}

function updateVolume(): void {
  // When we use regular Vue approach to render position and duration,
  // the value sometimes rendered multiple times.
  // For example, in Chrome, mobile width, if we click forward (+15sec)
  // button 3 times quickly and then start the playback, the position
  // value will be duplicated.
  // Similarly, when the audio is playing, if we select the position text
  // with mouse, it will be duplicated.
  // I think this is Vue bug, especially since it is reproduced just with
  // text selection - we do not do anything here.
  // I was also able to reproduce it with simple counter increasing in
  // `setInterval` handler.
  // On the other hand, it might be a combination of data setup and HTML
  // structure and can be caused by something in our code.
  //
  // As a last resort solution, I update timings manually here.
  // See #2150.
  //
  // We also save current position and duration into component fields
  // for tests, as they are invisible in HTML.

  if (props.volumeControl.value && !isNaN(props.volumeControl.value)) {
    value.value = props.volumeControl.value * 100
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.volumeControl.value > 0)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "player-volume__icon iconfont iplayer-volume",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.volumeControl.mute()))
        }))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "player-volume__icon iconfont iplayer-mute",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.volumeControl.unmute()))
        })),
    _createVNode(_unref(VueSlider), {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value).value = $event)),
      value: __props.volumeControl.value,
      min: 0,
      max: 100,
      class: "player__audioplayer player__volume-slider",
      dragOnClick: true,
      interval: 1,
      tooltip: "none",
      onChange: inputChange
    }, null, 8, ["modelValue", "value"])
  ]))
}
}

})